import { render, staticRenderFns } from "./HelloUser.vue?vue&type=template&id=56e4f30b&scoped=true"
import script from "./HelloUser.vue?vue&type=script&lang=ts"
export * from "./HelloUser.vue?vue&type=script&lang=ts"
import style0 from "./HelloUser.vue?vue&type=style&index=0&id=56e4f30b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4f30b",
  null
  
)

export default component.exports